import CustomIcon from "@/components/ui/custom-icon";
import { FC, KeyboardEvent } from "react";
import S from "./index.module.scss";
import clsx from "clsx";

interface ISearchInput {
  placeholder: string;
  $variant?: "black" | "white";
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

const SearchInput: FC<ISearchInput> = ({ placeholder, $variant = "black", value, onChange, onSubmit }) => {
  const enterDownHandler = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSubmit();
    }
  };

  return (
    <div className={S.searchWrapper}>
      <input
        className={clsx(S.customInput, { [S["customInput--black"]]: $variant === "black" })}
        value={value}
        onKeyDown={enterDownHandler}
        placeholder={placeholder}
        onChange={({ target }) => onChange(target.value)}
      />
      <div className={clsx(S.iconWrap, { [S["iconWrap--black"]]: $variant === "black" })}>
        <CustomIcon fileName="icon-search" />
      </div>
    </div>
  );
};

export default SearchInput;
